import { FC, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import AppToolsContext from '../../context/AppToolsContext';
import AppToolsView from '../AppToolsView/AppToolsView';
import { createAppToolbarItems } from '../../utils/AppToolbarItemFactory';
import useAppTools from '../../decorators/useAppTools';
import AppToolsThemeProviderCustomization from '../../../customizationTheme/AppToolsThemeProviderCustomization';
import useSessionIdFromRoute from 'hooks/useSessionIdFromRoute';
import AppToolsErrorMessage from '../AppToolsErrorMessage/AppToolsErrorMessage';
import { onAppToolGeneralErrorHandler } from '../../utils/ErrorHandler';
import useExtensionsAppTools from '../../decorators/useExtensionsAppTools';

export interface IAppToolsProps {
    eventUniqueName: string;
}

const AppTools: FC<IAppToolsProps> = ({ eventUniqueName }) => {
    const { sessionId } = useSessionIdFromRoute();

    const appTools = useAppTools(!!sessionId);
    const extensionsAppTools = useExtensionsAppTools(eventUniqueName, sessionId);

    const appToolbarItems = useMemo(() => {
        const allAppTools = [...appTools, ...extensionsAppTools];
        return createAppToolbarItems(allAppTools);
    }, [appTools, extensionsAppTools]);

    return (
        <AppToolsThemeProviderCustomization eventUniqueName={eventUniqueName}>
            <AppToolsContext.Provider
                value={{
                    eventUniqueName,
                    sessionId,
                }}
            >
                <ErrorBoundary
                    FallbackComponent={AppToolsErrorMessage}
                    onError={onAppToolGeneralErrorHandler}
                >
                    <AppToolsView appToolbarItems={appToolbarItems} />
                </ErrorBoundary>
            </AppToolsContext.Provider>
        </AppToolsThemeProviderCustomization>
    );
};

export default AppTools;
